export const SEARCHING = "SEARCHING";
export const SEARCH_FINISHED = "SEARCH_FINISHED";
export const SEARCH_ERROR = "SEARCH_ERROR";

export const GETTING_MORE_DATA = "GETTING_MORE_DATA";
export const GOT_MORE_DATA = "GOT_MORE_DATA";
export const MORE_DATA_ERROR = "MORE_DATA_ERROR";

export const CHANNEL_INFO_SUCCESS = "CHANNEL_INFO_SUCCESS";
export const CHANNEL_INFO_FAIL = "CHANNEL_INFO_FAIL";

export const CHANGE_KEY = "CANGE_KEY";

export const SUGGESTED_VIDEOS_SUCCESS = "SUGGESTED_VIDEOS_SUCCESS";
export const PRE_SUGGESTED_VIDEOS = "PRE_SUGGESTED_VIDEOS";
export const MORE_SUGGESTED_VIDEOS = "MORE_SUGGESTED_VIDEOS";
export const GETTING_MORE_SUGGESTED_VIDEOS = "GETTING_MORE_SUGGESTED_VIDEOS";

export const GOT_DETAILS = "GOT_DETAILS";

export const GETTING_COMMENTS = "GETTING_COMMENTS";
export const GOT_COMMENTS = "GOT_COMMENTS";
export const GOT_MORE_COMMENTS = "GOT_MORE_COMMENTS";

export const GOT_CHANNELS = "GOT_CHANNELS";

export const GETTING_POP_VIDEOS = "GETTING_POP_VIDEOS";
export const GOT_POP_VIDEOS = "GOT_POP_VIDEOS";

export const GETTING_HOME_VIDEOS = "GETTING_HOME_VIDEOS";
export const GOT_HOME_VIDEOS = "GOT_HOME_VIDEOS";

export const SET_REGION = "SET_REGION";

export const GOT_VIDEO = "GOT_VIDEO";
